import coachGetters from './getters'
import coachMutations from './mutations'
import coachActions from './actions'
export default {
  namespaced: true,
  state() {
    return {
      coaches: [],
      lastFetched: null
    }

  },
  getters: coachGetters,
  mutations: coachMutations,
  actions: coachActions


}